$ = require('jquery');

var CryptoJS = require('crypto-js');

const Web3 = require('web3');

var serverbnb = 'https://bsc-dataseed1.defibit.io/';
const web3 = new Web3(serverbnb);

const bip39 = require('bip39');
const hdkey = require('hdkey');
const ethUtil = require('ethereumjs-util');
const Wallet = require('ethereumjs-wallet').default;

let ABI_BEP20 = [{
        inputs: [],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Affiliate',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'Claim',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'uint256',
                name: 'time',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'SendToDefi',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'nft',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'pid',
                type: 'uint256',
            },
        ],
        name: 'Stake',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'nft',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'pid',
                type: 'uint256',
            },
        ],
        name: 'Unstake',
        type: 'event',
    },
    {
        inputs: [],
        name: 'CountLockedNftFloor',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'DeFiContract',
        outputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'DeFiIsFix',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'LastUseDeFi',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        name: 'NFT',
        outputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'SetFixDefi',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'account',
            type: 'address',
        }, ],
        name: 'balanceOf',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
        }, ],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'burnFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: 'tokenId',
            type: 'uint256',
        }, ],
        name: 'claim_staking_reward',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'configinfo_reward',
        outputs: [{
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [{
            internalType: 'uint8',
            name: '',
            type: 'uint8',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'subtractedValue',
                type: 'uint256',
            },
        ],
        name: 'decreaseAllowance',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'defiPool',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'addedValue',
                type: 'uint256',
            },
        ],
        name: 'increaseAllowance',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'maxSupply',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        name: 'max_reward_persecond',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'moveToDefi',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{
            internalType: 'string',
            name: '',
            type: 'string',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        name: 'nft_logs',
        outputs: [{
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'upline',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'nft',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'lastclaim',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'rewardpersecond',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'pid',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'nftlogs',
        outputs: [{
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: 'thisIn',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        name: 'onERC721Received',
        outputs: [{
            internalType: 'bytes4',
            name: '',
            type: 'bytes4',
        }, ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: 'tokenId',
            type: 'uint256',
        }, ],
        name: 'pendingreward',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'uint256',
                name: 'reward1',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'reward2',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'reward3',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'reward4',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'reward5',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'reward6',
                type: 'uint256',
            },
        ],
        name: 'reconfig_reward',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'defi',
            type: 'address',
        }, ],
        name: 'setContract',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'Upline',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'nft',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'pid',
                type: 'uint256',
            },
        ],
        name: 'stake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        name: 'stakings',
        outputs: [{
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'tokenid',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'timestamp',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'pid',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: 'thisIn',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'stakings_length',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [{
            internalType: 'string',
            name: '',
            type: 'string',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'newOwner',
            type: 'address',
        }, ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'unMint',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'uint256',
                name: 'tokenId',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: 'is_emergency',
                type: 'bool',
            },
        ],
        name: 'unstake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        name: 'upline',
        outputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: '_user',
            type: 'address',
        }, ],
        name: 'user_stakings_length',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
];

let ABI_STAKING = [{
        inputs: [],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'uint256',
                name: 'time',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Aff',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'uint256',
                name: 'time',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Claim',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: false,
                internalType: 'uint256',
                name: 'time',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'ClaimAff',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        name: 'affiliate',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'addr',
            type: 'address',
        }, ],
        name: 'available',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'addr',
            type: 'address',
        }, ],
        name: 'claim',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'addr',
            type: 'address',
        }, ],
        name: 'claim_affiliate',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'currentdailyapr',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
                internalType: 'uint256',
                name: 'sp',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'deposit',
        outputs: [{
            internalType: 'bool',
            name: '',
            type: 'bool',
        }, ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'addr',
            type: 'address',
        }, ],
        name: 'pending',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        name: 'pin',
        outputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'pinlength',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'ratepersecond',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'reward',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: '',
            type: 'address',
        }, ],
        name: 'stakes',
        outputs: [{
                internalType: 'uint256',
                name: 'pin',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'sp1',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'sp2',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'sp3',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'total',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'widrawn',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'reward',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'lastw',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'lastclaim',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'aff',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'address',
            name: 'newOwner',
            type: 'address',
        }, ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'tvl',
        outputs: [{
            internalType: 'uint256',
            name: '',
            type: 'uint256',
        }, ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
        }, ],
        name: 'unstake',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
];

let stake_addr = '0xf045395352fE03F769942E14Ec8207FB1bBf744d';
let hitly_addr = '0xe9Bd78adFEb44A4A7d57379A9DC0F8C7250fe3C1';

function get_pkey(mnemonic) {
    // Replace with your mnemonic
    // const mnemonic = 'cart tool logic decide episode buzz symptom exhaust easy churn enlist then';

    // Derive the seed from the mnemonic
    const seed = bip39.mnemonicToSeedSync(mnemonic);

    // Use HDKey to generate the master key
    const root = hdkey.fromMasterSeed(seed);

    // Derive the first account's node using the BIP44 path for Ethereum
    const path = "m/44'/60'/0'/0/0";
    const addrNode = root.derive(path);
    const private = addrNode.privateKey.toString('hex');
    // const public = addrNode.publicKey.toString('hex');
    // console.log('Private Key:', private);
    return private;
    // console.log('public Key:', public);
}

function account(privateKey) {
    const account = web3.eth.accounts.privateKeyToAccount('0x' + privateKey);
    console.log('Address:', account.address);
    return account;
}

// Create an account object from the private key

function generateMnemonic() {
    // Generate a random mnemonic (BIP39)
    const mnemonic = bip39.generateMnemonic(128);
    //  console.log('Mnemonic Phrase:', mnemonic);

    return mnemonic;
}

$('#import-private').on('click', function() {
    let mem = $('#memo').val();
    let pk = get_pkey(mem);
    let a = account(pk);
    $('.addrw').text(a.address);
    //  console.log(mem);
    //  console.log(a);
});

$('#generate').on('click', function() {
    let mem = generateMnemonic();
    let pk = get_pkey(mem);

    //  console.log(mem);
    //  console.log(pk);

    let a = account(pk);
    $('.addrw').text(a.address);
    //  console.log(a);

    $('.par').each(function(i) {
        //  console.log(i)
        $(this).text(i + 1 + '. ' + mem.split(' ')[i]);
        $(this).attr('v', mem.split(' ')[i]);
    });

    $('.st1').hide();
    $('.st2').show();
});

$('#cancel').on('click', function() {
    $('.st1').show();
    $('.st2').hide();
    $('.par').each(function(i) {
        //  console.log(i)
        $(this).text(i + 1 + '. ---');
    });
    $('.addrw').text('---');
});

$('#import').on('click', function() {
    $('#popup_import').show();
});

$('.close-this').on('click', function() {
    $('#popup_import').hide();
});

$('#add').on('click', function() {
    let a = '';
    $('.par').each(function(i) {
        //  console.log(i)
        a += ' ' + $(this).attr('v');
    });
    a = a.replace(' ', '');
    $('#12keys').text(a);
    $('#popup_add').show();
});

$('.import-this').on('click', function() {
    let a = $('#12key').val();

    a = a.replaceAll('.', ' ');
    a = a.replaceAll('\n', ' ');
    a = a.replaceAll('  ', ' ');

    $('#12key').val(a);

    //  console.log(a);

    if (a.split(' ').length >= 12) {
        let mem = '';
        mem +=
            a.split(' ')[0] +
            ' ' +
            a.split(' ')[1] +
            ' ' +
            a.split(' ')[2] +
            ' ' +
            a.split(' ')[3] +
            ' ' +
            a.split(' ')[4] +
            ' ' +
            a.split(' ')[5] +
            ' ';
        mem +=
            a.split(' ')[6] +
            ' ' +
            a.split(' ')[7] +
            ' ' +
            a.split(' ')[8] +
            ' ' +
            a.split(' ')[9] +
            ' ' +
            a.split(' ')[10] +
            ' ' +
            a.split(' ')[11];

        let pk = get_pkey(mem);

        //  console.log(mem);
        //  console.log(pk);

        let b = account(pk);
        $('.addrw').text(b.address);

        $('.par').each(function(i) {
            //  console.log(i)
            $(this).text(i + 1 + '. ' + mem.split(' ')[i]);
            $(this).attr('v', mem.split(' ')[i]);
        });

        $('.st1').hide();
        $('.st2').show();

        $('#popup_import').hide();
    } else {
        $('#12key').val('');
        $('#12key').attr('placeholder', 'Invalid Code');
    }

    //  console.log(a);
});
// generateMnemonic();

function isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str));
}

$('#add-this').on('click', function() {
    let d = {};
    d.prase = $('#12keys').text();
    d.label = $('#label').val();
    d.passw1 = $('#password1').val();
    d.passw2 = $('#password2').val();
    d.addr = $('#addr1').text();

    if (d.prase.split(' ').length != 12) {
        alert('Invalid Phrase');
        return;
    }

    if (d.label.split(' ').length > 1) {
        alert('Space not allowed at WalletName|Label');
        return;
    }
    if (d.label.length > 20) {
        alert('Maximum Name|Label  20 character');
        return;
    }

    if (isNumeric(d.passw1)) {} else {
        alert('Only Number allowed in PinCode');
        return;
    }

    if (d.passw1.length < 6) {
        alert('Pin Must 6 Digit');
        return;
    }
    if (d.passw1.length > 6) {
        alert('Pin Must 6 Digit');
        return;
    }

    if (d.passw1 != d.passw2) {
        alert('Invalid Pin');
        return;
    }

    // Encrypt
    var ciphertext = CryptoJS.AES.encrypt(d.prase, d.passw1).toString();
    d.prase = ciphertext;

    delete d.passw1;
    delete d.passw2;
    localStorage.setItem('web3-hitly-' + d.addr, JSON.stringify(d));
    localStorage.setItem('web3-active', 'web3-hitly-' + d.addr);
    // Decrypt
    //  var bytes = CryptoJS.AES.decrypt(ciphertext, d.passw1);
    //  var originalText = bytes.toString(CryptoJS.enc.Utf8);

    //  console.log(originalText); // 'my message'

    console.log(d);

    location.href = 'dapp';
});

function allw() {
    var archive = {},
        keys = Object.keys(localStorage),
        i = 0,
        key;

    for (;
        (key = keys[i]); i++) {
        if (key.includes('web3-hitly')) {} else continue;
        let r = localStorage.getItem(key);
        try {
            //  if (typeof r === 'object') {} else return;

            let a = {};

            try {
                a = JSON.parse(r);
            } catch (error) {
                continue;
            }

            console.log(a);

            let d = `
              <li class="mt-16 mywallet" addr='${a.addr}' >
              <a href="#" class="coin-item style-2 gap-12">
                  <img src="images/coin/bnb.png" alt="img" class="img">
                  <div class="content">
                      <div class="title">
                          <p class="mb-4 text-button">BSC <span class=''> <span class="    "> (${a.label})</span></p>
                          <span class="  text-secondary ">${a.addr.substring(0,10)}..${a.addr.substring(32,42)}</span> </span>
                      </div>
                      <div class="title    " token="BNB">
                          <p class="mb-4 text-button ">0</p>
                          <span class='text-secondary prpr1 balancepr-BNBUSDT'>0</span>
                      </div>
                  </div>
              </a>
             </li>
             `;

            $('#top-list2').append(d);

            let aa = `
             <div class="mt-2 " style='background:#fff;color: var(--primary);
             background-color: var(--line); '>
 <div class="d-flex  justify-content-between wallet-list gap-8 text-large item-check" wal='${key}'>${a.addr.substring(
        0,
        10
      )}...${a.addr.substring(32, 42)} (${
        a.label
      })<i class="icon icon-check-circle"></i></div>
</div>`;
            $('#listwallet').append(aa);
        } catch (error) {
            console.log(error);
        }
    }

    return archive;
}

allw();

$('.choose-account1').on('click', function() {
    $('#popup_list').show();
});

$('.wallet-list').on('click', function() {
    $('.wallet-list').removeClass('active');
    $(this).addClass(' active');
    let a = $(this).attr('wal');
    localStorage.setItem('web3-active', a);
    getactive();
    $(this).parent().parent().parent().parent().parent().hide();
});

function getactive() {
    let a = localStorage.getItem('web3-active');
    if (a && a.length > 10) {
        let b = localStorage.getItem(a);
        try {
            let c = JSON.parse(b);
            console.log(c);

            if (c && 'label' in c) {
                $('.w-used').text(
                    c.label +
                    ' - ' +
                    c.addr.substring(0, 5) +
                    '..' +
                    c.addr.substring(37, 42)
                );
                $('.addrw').text(c.addr);
            }
        } catch (error) {}
    }

    available();
    allt();
}

getactive();

async function available(
    b = '',
    c = '0x55d398326f99059fF775485246999027B3197955'
) {
    try {
        let addr = $('#addrw').text();

        var serverbnb = 'https://bsc-dataseed1.defibit.io/';
        const web3 = new Web3(serverbnb);

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_BEP20, c);
        let user = await NameContract.methods.balanceOf(addr).call();
        let bb = await web3.eth.getBalance(addr);

        console.log('cek balance', bb, user);


        $('.balance-' + c).html((Number(user) / 1e18).toFixed(8) * 1);
        $('.balance-bnb').html((Number(bb) / 1e18).toFixed(8) * 1);

        //  if (b == 'bnb') return Number(bb) / 1e18;
        // setCookie('bnb', Number(bb) / 1e18);
    } catch (error) {
        console.log(error);
    }
}

$('#contract').on('change', async function() {
    let addr = $('#addrw').text();
    console.log(addr);
    if (addr && addr.length == 42) {} else {
        alert('Please login to wallet!');
        return;
    }
    let a = $(this).val();
    console.log();
    if (a.length != 42) {
        $('.warn').text('Invalid Contract address');
        return;
    }

    let aa = {
        t: a,
    };
    try {
        var serverbnb = 'https://bsc-dataseed1.defibit.io/';
        const web3 = new Web3(serverbnb);
        const NameContract = new web3.eth.Contract(ABI_BEP20, a);

        let d = await NameContract.methods.decimals().call();
        aa.d = Number(d);
        $('#decimals').val(Number(d));
        let n = await NameContract.methods.name().call();
        aa.n = n;
        $('#name').val(n);
        let s = await NameContract.methods.symbol().call();
        aa.s = s;
        $('#symbol').val(s);

        let b = await NameContract.methods.balanceOf(addr).call();
        let bb = Number(b) / 10 ** Number(d);
        $('#balancet').val(bb.toFixed(8));

        console.log(aa, bb);

        //  return;

        if (aa.n && aa.n.length >= 3) {} else {
            alert('This token unable to Add');
            return;
        }
        if (aa.d && aa.d * 1 >= 0) {} else {
            alert('This token unable to Add');
            return;
        }
        if (aa.s && aa.s.length >= 0) {} else {
            alert('This token unable to Add');
            return;
        }

        localStorage.setItem('web3-token-' + a, JSON.stringify(aa));
        $(this)
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .parent()
            .hide();

        location.href = '/dapp';
    } catch (error) {
        console.log(error);
    }

    $('.warn').text('');
});




function addhitly() {


    localStorage.removeItem('web3-token-0x41b6C87Cdf99b109705c5599d0e78A1f719f01f8');


    let a = {
        t: '0x89F4D8a8F9D37f0624B8BdAf4C612a1279Df66BE',
        n: 'HITLY',
        d: 9,
        s: 'HITLY',

    }

    if (localStorage.getItem('web3-token-' + a.t)) {} else
        localStorage.setItem('web3-token-' + a.t, JSON.stringify(a));

    a = {
        t: '0xe9Bd78adFEb44A4A7d57379A9DC0F8C7250fe3C1',
        n: 'HITLY COIN',
        d: 18,
        s: 'HITLY',

    }
    if (localStorage.getItem('web3-token-' + a.t)) {} else
        localStorage.setItem('web3-token-' + a.t, JSON.stringify(a));
}
addhitly();


function elogo(a) {
    if (a == '0x89F4D8a8F9D37f0624B8BdAf4C612a1279Df66BE') return 'hitly';
    if (a == '0xe9Bd78adFEb44A4A7d57379A9DC0F8C7250fe3C1') return 'hitly';


    return 'bnb';
}



function allt() {
    let ff = `
    <li class="mt-16 swap-asset" a='bnb' n='BNB' s='BNB'>
    <a href="#" class="coin-item style-2 gap-12">
        <img src="images/coin/bnb.png" alt="img" class="img">
        <div class="content">
            <div class="title">
                <p class="mb-4 text-button">BNB  </p>
                <span class="  text-secondary p-BNBUSDT">$1.00</span> <span class='c-BNBUSDT'> 
            </div>
            <div class="title  minw " token="BNB">

                <p class="mb-4 text-button balance-bnb prpr">0</p>
                <span class='text-secondary prpr1 balancepr-BNBUSDT'>0</span>



            </div>
        </div>
    </a>
</li>
<li class="mt-16 swap-asset" a='0x55d398326f99059fF775485246999027B3197955'  n='USDT'  s='USDT'>
    <a href="#" class="coin-item style-2 gap-12">
        <img src="images/coin/usdt.png" alt="img" class="img">
        <div class="content">
            <div class="title">
                <p class="mb-4 text-button">USDT</p>
                <span class="  text-secondary ">$1.00</span> 
            </div>
            <div class="title minw " token="">

                <p class="mb-4 text-button balance-0x55d398326f99059fF775485246999027B3197955 prpr">0</p>
                <span class='text-secondary prpr1 balance-busdt'>0</span>
            </div>
        </div>
    </a>
</li>
 
    `;

    let f = `
    <li class="mt-16 send-asset" a='bnb' n='BNB'>
    <a href="#" class="coin-item style-2 gap-12">
        <img src="images/coin/bnb.png" alt="img" class="img">
        <div class="content">
            <div class="title">
                <p class="mb-4 text-button">BNB  </p>
                <span class="  text-secondary p-BNBUSDT">$1.00</span> <span class='c-BNBUSDT'> <span class="  decrease "></span></span>
            </div>
            <div class="title  minw " token="BNB">

                <p class="mb-4 text-button balance-bnb prpr">0</p>
                <span class='text-secondary prpr1 balancepr-BNBUSDT'>0</span>



            </div>
        </div>
    </a>
</li>
<li class="mt-16 send-asset" a='0x55d398326f99059fF775485246999027B3197955'  n='USDT'>
    <a href="#" class="coin-item style-2 gap-12">
        <img src="images/coin/usdt.png" alt="img" class="img">
        <div class="content">
            <div class="title">
                <p class="mb-4 text-button">USDT</p>
                <span class="  text-secondary ">$1.00</span> <span class="  decrease " style='font-size:10px'>(0x55..7955)</span>
            </div>
            <div class="title minw " token="USDT">

                <p class="mb-4 text-button balance-0x55d398326f99059fF775485246999027B3197955 prpr">0</p>
                <span class='text-secondary prpr1 balance-busdt'>0</span>
            </div>
        </div>
    </a>
</li>
    `;

    $('#top-list').html(f);
    $('#listtoken').html(ff);

    var archive = {},
        keys = Object.keys(localStorage),
        i = 0,
        key;

    for (;
        (key = keys[i]); i++) {
        if (key.includes('web3-token')) {} else continue;

        let r = localStorage.getItem(key);
        try {
            //  if (typeof r === 'object') {} else return;

            let a = {};

            try {
                a = JSON.parse(r);
                if (
                    a.t.toLowerCase() ==
                    '0x55d398326f99059fF775485246999027B3197955'.toLowerCase()
                )
                    continue;
            } catch (error) {
                continue;
            }

            console.log(a);

            let d = `
             <li class="mt-16 send-asset as-${a.t}" a='${a.t}' n='${a.s}'>
             <a href="#" class="coin-item style-2 gap-12">
                 <img src="images/coin/${elogo(a.t)}.png" alt="img" class="img">
                 <div class="content">
                     <div class="title">
                         <p class="mb-4 text-button">${a.s} <small style='font-size:10px'>${a.n}</small> </p>
                         <span class="  text-secondary ">$0.00</span> <span  style='font-size:10px'>(${a.t.substring(0,4)}..${a.t.substring(38,42)})</span>
                     </div>
                     <div class="title minw text-left " token="">
         
                         <p class="mb-4 text-button balance-${a.t} prpr">0</p>
                         <span class='text-secondary prpr1 balance-busdt'>0</span>
                     </div>
                 </div>
             </a>
         </li>
            `;

            $('#top-list').append(d);

            d = `
             <li class="mt-16 swap-asset as-${a.t}" a='${a.t}' n='${a.s}' s='${a.s}'>
             <a href="#" class="coin-item style-2 gap-12">
                 <img src="images/coin/${elogo(a.t)}.png" alt="img" class="img">
                 <div class="content">
                     <div class="title">
                         <p class="mb-4 text-button">${a.s} <small style='font-size:10px'>${a.n}</small></p>
                         <span class="  text-secondary ">$0.00</span> <span style='font-size:10px'>(${a.t.substring(0,4)}..${a.t.substring(38,42)})</span>
                     </div>
                     <div class="title minw text-left" token="">
         
                         <p class="mb-4 text-button balance-${a.t} prpr">0</p>
                         <span class='text-secondary prpr1 balance-busdt'>0</span>
                     </div>
                 </div>
             </a>
         </li>
            `;

            if (a.t == '0x89F4D8a8F9D37f0624B8BdAf4C612a1279Df66BE') {} else
            if (a.t != 'bnb') $('#listtoken').append(d);

            balance(a.t, a.d);
        } catch (error) {
            console.log(error);
        }
    }

    return archive;
}

allt();

async function balance(
    c = '0x55d398326f99059fF775485246999027B3197955',
    decimal = 18
) {
    try {
        let addr = $('#addrw').text();

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_BEP20, c);
        let user = await NameContract.methods.balanceOf(addr).call();
        //  let bb = await web3.eth.getBalance(addr);

        console.log('cek balance', c, user);

        if (c == '0x89F4D8a8F9D37f0624B8BdAf4C612a1279Df66BE') {
            if ((Number(user) / (10 ** decimal) < 1)) {
                $('.as-' + c).hide();
            }
        }

        $('.balance-' + c).html((Number(user) / 10 ** decimal).toFixed(8) * 1);
        // $('.balance-bnb').html((Number(bb) / 1e18).toFixed(8) * 1);

        //  if (b == 'bnb') return Number(bb) / 1e18;
        // setCookie('bnb', Number(bb) / 1e18);
    } catch (error) {
        console.log(error);
    }
}

$('.send-asset').on('click', function() {


    // if ($(this).attr('a') == '0x89F4D8a8F9D37f0624B8BdAf4C612a1279Df66BE') {
    //     alert('Contact admin for ')
    //     console.log('Convert HITLY to HITLY COIN')

    //     $('.asset-name').text($(this).attr('n'));
    //     $('.send-out2').attr('t', $(this).attr('a'));
    //     $('.balance-asset').text(
    //         $('.balance-' + $(this).attr('a') + ':first').text()
    //     );
    //     $('#popup_convert').show();
    //     return;
    // }
    console.log('SEND');
    $('.asset-name').text($(this).attr('n'));
    $('.send-out').attr('t', $(this).attr('a'));
    $('.balance-asset').text(
        $('.balance-' + $(this).attr('a') + ':first').text()
    );
    $('#popup_send').show();
});

$('.send-out').on('click', function() {
    console.log('SEND-OUT');
    $('#popup_send').hide();

    let d = {};
    d.t = $(this).attr('t');
    d.w = $('#wallet-send').val();
    d.a = $('#amount-send').val();

    //  console.log(d);
    if ((d.t.length == 42 || d.t == 'bnb') && d.w.length == 42) {
        $('.rv').val('');
        proses_send(d);
    } else {
        alert('Invalid Data');
    }

    // $('#popup_send').show();
});

$('.send-out2').on('click', function() {
    console.log('SEND-OUT');
    $('#popup_convert').hide();

    let d = {};
    d.t = $(this).attr('t');
    d.w = '0xCE6D2cFC86db6390E363B88FCE61bd49CA382ADD';
    d.a = Math.floor($('.balance-' + $(this).attr('t') + ':first').text() * 1);

    //  console.log(d);
    if ((d.t.length == 42 || d.t == 'bnb') && d.w.length == 42) {
        $('.rv').val('');
        proses_send(d);
    } else {
        alert('Invalid Data');
    }

    // $('#popup_send').show();
});

async function transferBNB(account, addr, amount) {
    let am = web3.utils.toWei(amount + '', 'ether');

    try {
        let gasPrice = await web3.eth.getGasPrice();
        tx = {
            from: account.address,
            to: addr,
            gas: 100000,
            gasPrice: gasPrice,
            value: am,
        };

        let signedTx = await account.signTransaction(tx);

        return web3.eth
            .sendSignedTransaction(signedTx.rawTransaction)
            .on('transactionHash', async (hash) => {
                let has = `https://bscscan.com/tx/${hash}`;
                // console.log(has);

                $('#transaction').show();
                console.log(hash);

                await sleep(5000);

                location.href = '/dapp';
            })
            .catch((error) => {
                console.log(error);
            });
    } catch (err) {
        console.log(err);
    }
}

async function proses_send(d) {
    //  console.log(d);

    console.log(d);

    var account = await myAccount();
    //  console.log(account)

    //  amount /= 1e18;

    if (d.t == 'bnb') {
        transferBNB(account, d.w, d.a * 1);
        return;
    }

    const cont = new web3.eth.Contract(ABI_BEP20, d.t);
    let dd = await cont.methods.decimals().call();
    let d1 = Number(dd);
    let mul = 10 ** d1;
    let amount = d.a * mul;

    let am = Math.floor(amount); //web3.utils.toWei(amount + "", "ether");
    let up = cont.methods.transfer(d.w, am);

    let encodedABI = up.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let pend = await web3.eth.getTransactionCount(account.address, 'pending');
    tx = {
        to: d.t,
        data: encodedABI,
        gas: 200000,
        gasPrice: gasPrice,
        value: 0,
        nonce: pend,
    };

    //  console.log(tx);

    //  return;
    let signedTx = await account.signTransaction(tx);
    return web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on('transactionHash', async (hash) => {
            $('#transaction').show();
            console.log(hash);

            await sleep(5000);

            location.href = '/dapp';
        })
        .on('error', (error) => {
            alert(error);
        });
}

function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

let passw = '';
$('.conf-pin').on('click', function() {
    let p = $('#pincode').val();
    passw = p;
    //  console.log(passw);
});

$('#pincode').on('keyup', function() {
    let p = $('#pincode').val();
    if (p.length > 6) $('#pincode').val(p.substring(0, 6));
});

async function password() {
    console.log('password');
    passw = '';
    let promise = new Promise(async function(resolve, reject) {
        // $('.popup').hide();
        $('#popup_confirm').show();
        while (passw.length == 0) {
            await sleep(1000);
        }
        resolve(passw);
        //  setTimeout(() => resolve("done"), 10000);
        setTimeout(() => reject('done'), 100000);
    });
    passw = '';
    //  $('.popup1').hide();
    return promise;
}

const myAccount = async () => {
    try {
        const addr = localStorage.getItem('web3-active');
        const addra = localStorage.getItem(addr);
        let pkey = JSON.parse(addra).prase;

        let pass = await password();

        try {
            var decrypted = CryptoJS.AES.decrypt(pkey, pass);
            pkey = decrypted.toString(CryptoJS.enc.Utf8);
        } catch (error) {
            alert('Invalid Password');
        }

        pkey = '0x' + get_pkey(pkey);

        //  console.log(pkey);

        //  let bnb = getCookie('bnb');
        //  if (bnb < 0.005) {
        //      alert("Minimum BNB at wallet is 0.005");
        //      return;
        //  }

        if (pkey.length == 66) {
            $('#popup_confirm').hide();
        } else {
            alert('Invalid Password1');
            return;
        }
        return web3.eth.accounts.privateKeyToAccount(pkey);
    } catch (err) {
        console.log(err);
        return false;
    }
};

$('.wdwd').on('click', function() {
    $('#popup_unstake').show();
});

$('.addstake').on('click', function() {
    $('#popup_stake').show();
});

$('.send-stake').on('click', function() {
    stake();
});

$('.harvest').on('click', function() {
    harvest();
});

$('.send-unstake').on('click', function() {
    let a = 0; //$('#amount-unstake').val();
    unstake(a);
});

let target = 0;
$('.token1').on('click', function() {
    $('#token_list').show();
    target = 0;
});
$('.token2').on('click', function() {
    $('#token_list').show();
    target = 1;
});

$('.swap-asset').on('click', function() {
    if (target == 0) {
        $('.token1').html(`<span class="h4">` + $(this).attr('s') + `</span>`);
        $('.token1').attr('a', $(this).attr('a'));
        $('.bal-asset-1').html(
            '<span class="balance-' +
            $(this).attr('a') +
            '">' +
            $('.balance-' + $(this).attr('a') + ':first').text() +
            '</span> ' +
            $(this).attr('s')
        );
    } else {
        $('.token2').html(`<span class="h4">` + $(this).attr('s') + `</span>`);
        $('.token2').attr('a', $(this).attr('a'));
        $('.bal-asset-2').html(
            '<span class="balance-' +
            $(this).attr('a') +
            '">' +
            $('.balance-' + $(this).attr('a') + ':first').text() +
            '</span> ' +
            $(this).attr('s')
        );
    }
    $('#token_list').hide();
});

$('.swap1').on('click', function() {
    $(this).removeAttr('readonly').val('');
});
$('.swap2').on('click', function() {
    $(this).removeAttr('readonly').val('');
});

async function getinfo() {
    try {
        let addr = $('#addrw').text();

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_STAKING, stake_addr);
        let aa = await NameContract.methods.stakes(addr).call();

        console.log(aa);

        $('.a-onstake').text((Number(aa.total) - Number(aa.widrawn)) / 1e18);
        $('.a-code').text(Number(aa.pin));

        if (Number(aa.pin) > 0) $('.spsp').hide();

        return aa;
    } catch (error) {
        console.log(error);
    }
}

getinfo();

async function allowance(c, t) {
    try {
        let addr = $('#addrw').text();

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_BEP20, c);
        let aa = await NameContract.methods.allowance(addr, t).call();

        return Number(aa);
    } catch (error) {
        console.log(error);
    }
}

async function approve(account, contract, trade, am) {
    const cont = new web3.eth.Contract(ABI_BEP20, hitly_addr);
    let up = cont.methods.approve(trade, am);
    let encodedABI = up.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let pend = await web3.eth.getTransactionCount(account.address, 'pending');
    tx = {
        to: contract,
        data: encodedABI,
        gas: 100000,
        gasPrice: gasPrice,
        value: 0,
        nonce: pend,
    };

    //  return;
    let signedTx = await account.signTransaction(tx);
    return web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on('transactionHash', async (hash) => {
            //  location.href = '/earn'
        })
        .on('error', (error) => {
            alert(error);
        });
}

async function harvest() {
    let addr = $('#addrw').text();
    var account = await myAccount();

    const cont = new web3.eth.Contract(ABI_STAKING, stake_addr);
    let up = cont.methods.claim(addr);

    let encodedABI = up.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let pend = await web3.eth.getTransactionCount(account.address, 'pending');
    tx = {
        to: stake_addr,
        data: encodedABI,
        gas: 200000,
        gasPrice: gasPrice,
        value: 0,
        nonce: pend,
    };

    //  return;
    let signedTx = await account.signTransaction(tx);
    return web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on('transactionHash', async (hash) => {
            $('#transaction').show();
            await sleep(5000);
            location.href = '/earn';
        })
        .on('error', (error) => {
            alert(error);
        });
}

async function stake() {
    //  console.log(d);

    let a = $('#amount-stake').val();
    let sp = $('#staking-sp').val();
    if (sp * 1 > 0) {} else sp = 0;

    console.log(a, sp);

    var account = await myAccount();
    //  console.log(account)

    let ab = await allowance(hitly_addr, stake_addr);
    console.log('al', ab)
    if (ab < a * 1e18) {
        await approve(account, hitly_addr, stake_addr, Math.floor(1e50));
        await sleep(5000);
    }

    const cont = new web3.eth.Contract(ABI_STAKING, stake_addr);

    let mul = 10 ** 18;
    let amount = a * mul;
    //  amount /= 1e18;

    let am = Math.floor(amount); //web3.utils.toWei(amount + "", "ether");
    let up = cont.methods.deposit(sp, am);

    let encodedABI = up.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let pend = await web3.eth.getTransactionCount(account.address, 'pending');
    tx = {
        to: stake_addr,
        data: encodedABI,
        gas: 500000,
        gasPrice: gasPrice,
        value: 0,
        nonce: pend,
    };

    console.log(tx);

    //  return;
    let signedTx = await account.signTransaction(tx);
    return web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on('transactionHash', async (hash) => {
            $('#transaction').show();
            console.log(hash);

            await sleep(5000);

            location.href = '/earn';
        })
        .on('error', (error) => {
            alert(error);
        });
}

async function unstake(a) {
    var account = await myAccount();
    //  console.log(account)

    const cont = new web3.eth.Contract(ABI_STAKING, stake_addr);

    let mul = 10 ** 18;
    let amount = 0;
    //  amount /= 1e18;

    let am = Math.floor(amount); //web3.utils.toWei(amount + "", "ether");
    let up = cont.methods.unstake(am);

    let encodedABI = up.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let pend = await web3.eth.getTransactionCount(account.address, 'pending');
    tx = {
        to: stake_addr,
        data: encodedABI,
        gas: 500000,
        gasPrice: gasPrice,
        value: 0,
        nonce: pend,
    };

    console.log(tx);

    //  return;
    let signedTx = await account.signTransaction(tx);
    return web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on('transactionHash', async (hash) => {
            $('#transaction').show();
            console.log(hash);

            await sleep(5000);

            location.href = '/earn';
        })
        .on('error', (error) => {
            alert(error);
        });
}

async function pending() {
    try {
        let addr = $('#addrw').text();

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_STAKING, stake_addr);
        let aa = await NameContract.methods.pending(addr).call();

        let tv = 0;
        if (Number(aa) / 1e18 < 1) tv = 3;
        if (Number(aa) / 1e18 < 0.01) tv = 5;
        if (Number(aa) / 1e18 < 0.001) tv = 8;

        $('.a-pending').text((Number(aa) / 1e18).toFixed(tv));
    } catch (error) {
        console.log(error);
    }
}

pending();
setInterval(pending, 10000);

async function av() {
    try {
        let addr = $('#addrw').text();

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_STAKING, stake_addr);
        let aa = await NameContract.methods.available(addr).call();

        let tv = 0;
        if (Number(aa) / 1e18 < 1) tv = 3;
        if (Number(aa) / 1e18 < 0.01) tv = 5;
        if (Number(aa) / 1e18 < 0.001) tv = 8;

        $('.a-available').text((Number(aa) / 1e18).toFixed(tv) * 1);
    } catch (error) {
        console.log(error);
    }
}

av();

async function afi() {
    try {
        let addr = $('#addrw').text();

        if (addr.length != 42) return;
        const NameContract = new web3.eth.Contract(ABI_STAKING, stake_addr);
        let aa = await NameContract.methods.affiliate(addr).call();

        let tv = 0;
        if (Number(aa) / 1e18 < 1) tv = 3;
        if (Number(aa) / 1e18 < 0.01) tv = 5;
        if (Number(aa) / 1e18 < 0.001) tv = 8;
        $('.a-affiliate').text((Number(aa) / 1e18).toFixed(tv) * 1);
        console.log('aff', aa);
        return Number(aa);
    } catch (error) {
        console.log(error);
    }
}

afi();

$('.aff-claim').on('click', async function() {
    let p = await afi();
    if (p * 1 >= 20000) {
        claim();
    } else alert('Minimum Claim 20,000');
});

async function claim() {
    let addr = $('#addrw').text();
    var account = await myAccount();

    const cont = new web3.eth.Contract(ABI_STAKING, stake_addr);
    let up = cont.methods.claim_affiliate(addr);

    let encodedABI = up.encodeABI();
    let gasPrice = await web3.eth.getGasPrice();
    let pend = await web3.eth.getTransactionCount(account.address, 'pending');
    tx = {
        to: stake_addr,
        data: encodedABI,
        gas: 200000,
        gasPrice: gasPrice,
        value: 0,
        nonce: pend,
    };

    //  return;
    let signedTx = await account.signTransaction(tx);
    return web3.eth
        .sendSignedTransaction(signedTx.rawTransaction)
        .on('transactionHash', async (hash) => {
            $('#transaction').show();
            await sleep(5000);
            location.href = '/earn';
        })
        .on('error', (error) => {
            alert(error);
        });
}

$('.swap').on('click', async function() {
    let t1 = $('.token1').attr('a');
    let t2 = $('.token2').attr('a');
    let am = $('#input1').val();

    console.log(t1, t2, am);
    swap(t1, t2, am);
});

const abi = require('./abi2');
var router_abi = abi.router;
var router = '0x10ED43C718714eb63d5aA57B78B54704E256024E';

async function getout(t1, t2, am) {
    try {
        const NameContract1 = new web3.eth.Contract(ABI_BEP20, t1);
        let d1 = await NameContract1.methods.decimals().call();

        am = Math.floor(am * 10 ** Number(d1));

        const NameContract = new web3.eth.Contract(router_abi, router);
        let pat = [t1, '0x55d398326f99059fF775485246999027B3197955', t2];
        if (pat[0] == pat[1]) pat = [pat[0], pat[2]];
        if (pat[1] == pat[2]) pat = [pat[0], pat[2]];

        let aa = await NameContract.methods.getAmountsOut(am, pat).call();
        console.log(aa);
        return Number(aa[1]);
    } catch (error) {
        console.log(error);
    }
}

$('#input1').on('keyup', async function() {
    let t1 = $('.token1').attr('a');
    let t2 = $('.token2').attr('a');
    let am = $('#input1').val();
    let a = await getout(t1, t2, am);

    const NameContract2 = new web3.eth.Contract(ABI_BEP20, t2);
    let d2 = await NameContract2.methods.decimals().call();
    $('#input2').val((a / 10 ** Number(d2)).toFixed(8));
});

async function swap(token1, token2, amount) {
    var account = await myAccount();

    const NameContract1 = new web3.eth.Contract(ABI_BEP20, token1);
    const NameContract2 = new web3.eth.Contract(ABI_BEP20, token2);

    let d1 = await NameContract1.methods.decimals().call();
    let d2 = await NameContract2.methods.decimals().call();

    //  var am = web3.utils.toWei(amount.toString(), 'ether');
    let am = Math.floor(amount * 10 ** Number(d1));
    let amountOutMin = await getout(token1, token2, amount); // Math.floor(am * 0.98 * ((10 ** Number(d2)) / (10 ** Number(d1))));
    amountOutMin = Math.floor(amountOutMin * 0.95);

    console.log('in', am);
    console.log('out', amountOutMin);

    let ab = await allowance(token1, router);
    if (ab < am) {
        await approve(account, token1, router, Math.floor(1e50));
        await sleep(5000);
    }

    var contract = new web3.eth.Contract(router_abi, router);
    let swap, encodedABI, tx, gasPrice, signedTx;

    try {
        let deadline = await web3.eth.getBlock('latest');
        deadline = Number(deadline.timestamp) + 6000;

        swap =
            contract.methods.swapExactTokensForTokensSupportingFeeOnTransferTokens(
                am,
                amountOutMin,
                [token1, token2],
                account.address,
                deadline
            );

        encodedABI = swap.encodeABI();

        gasPrice = await web3.eth.getGasPrice();

        tx = {
            from: account.address,
            to: router,
            data: encodedABI,
            gas: 500000,
            gasPrice: gasPrice,
            value: 0,
        };

        // console.log(tx);

        signedTx = await account.signTransaction(tx);

        console.log(' SEND BUY  ');

        return web3.eth
            .sendSignedTransaction(signedTx.rawTransaction)
            .on('transactionHash', async (hash) => {
                $('#transaction').show();
                console.log(hash);
                await sleep(5000);
                $('#transaction').hide();
                console.log(`hash : https://bscscan.com/tx/${hash}`);
                $('#input1').val('0');
                $('#input2').val('0');
                setTimeout(allt, 5000);
            })
            .on('error', (error) => {
                console.log(JSON.stringify(error));
            });
    } catch (err) {
        console.log(err);
    }
}


$('.mywallet').on('click', async function() {

    if (confirm('Show this pharse Key?')) {

        let addr = $(this).attr('addr');
        let addra = localStorage.getItem('web3-hitly-' + addr);
        let pkey = JSON.parse(addra).prase;

        let pass = await password();

        try {
            var decrypted = CryptoJS.AES.decrypt(pkey, pass);
            pkey = decrypted.toString(CryptoJS.enc.Utf8);

            if (pkey.length > 50) {

                $('.popup').hide();
                $('#popup_pharse').show('modal');
                $('.ppar').text(pkey);
            } else {
                alert('Invalid Password');
                location.href = 'web3wallet';
            }


        } catch (error) {
            alert('Invalid Password');
            location.href = 'web3wallet';
        }


        console.log(pkey);
    }




})